import { render, staticRenderFns } from "./NewContentFromTemplateModal.vue?vue&type=template&id=b1705680&scoped=true"
import script from "./NewContentFromTemplateModal.vue?vue&type=script&lang=js"
export * from "./NewContentFromTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./NewContentFromTemplateModal.vue?vue&type=style&index=0&id=b1705680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1705680",
  null
  
)

export default component.exports